import {NavBar, Home, About, Skills, Work, Contact} from './components'

function App() {
	return (
		<div>
			<NavBar />
			<Home />
			<About />
			<Skills />
			<Work />
			<Contact />
		</div>
	)
}

export default App
